import { AnchorHTMLAttributes } from 'react';
import { useMemo, ElementType } from 'react';
import Link from 'next/link';

type ConditionalLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href?: string;
  component?: ElementType;
};

const getRelativeRoute = (href: string) => {
  if (href?.startsWith('#')) return href;

  try {
    const url = new URL(href, window.location.origin);
    const currentHost = window.location.hostname;
    const hostMatch = url.hostname === currentHost;
    return hostMatch ? `${url.pathname}${url.search}` : null;
  } catch {
    return null;
  }
};

export const ConditionalLink = ({ href, ...props }: ConditionalLinkProps) => {
  const { disabled, ...updatedProps } = props as any;
  const relativeRoute = useMemo(() => (href ? getRelativeRoute(href) : null), [href]);

  if (!href) return null;

  if (relativeRoute) {
    return <Link href={relativeRoute} {...updatedProps} />;
  }
  return <Link href={href} {...updatedProps} />;
};
